




























































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { Student } from '@/models/student/student';
import { StudentDraggableExtraArea } from '@/models/student/student-draggable-extra-area';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { StudentsByClass } from '@/models/student/students-by-class';
import { studentModule } from '@/store/modules/entities/student.module';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GSchoolClassBulkMoveModal',
  components: { GStudentRecordValueCell, GStudentRecordItemCell },
  computed: {},
  methods: {},
})
export default class GSchoolClassBulkMoveModal extends Mixins(GPageBase) {
  selectedSchoolClassID: number = -1;
  indeterminate: boolean = false;
  checkAll: boolean = false;
  modal: boolean = false;

  @Watch('bulkMoveModal')
  openModal(value: boolean) {
    // モーダルを開いたタイミングで初期化する
    this.selectedSchoolClassID = -1;
    this.indeterminate = false;
    this.checkAll = false;
    this.modal = value;
  }

  mounted() {}

  get fromName(): string {
    return schoolClassChangeModule.fromName;
  }

  get bulkMoveModal(): boolean {
    return schoolClassChangeModule.bulkMoveModal;
  }

  get bulkStudents(): Student[] {
    return schoolClassChangeModule.bulkStudents;
  }

  get bulkMoveStudents(): Student[] {
    return this.bulkStudents.filter((student: Student) => !student.checked);
  }

  get schoolClasses(): SchoolClass[] {
    const gradeSchoolClass: GradeSchoolClass = schoolClassModule.gradeSchoolClasses.find((gradeSchoolClass: GradeSchoolClass) => gradeSchoolClass.grade === schoolClassChangeModule.selectedGrade);
    if (gradeSchoolClass) {
      return gradeSchoolClass.schoolClasses;
    }
    return [];
  }

  get studentDraggableExtraArea(): StudentDraggableExtraArea {
    return schoolClassChangeModule.studentDraggableExtraArea;
  }

  get toDragAreaOptions(): any[] {
    return [
      {
        value: GEnum.DragAreaType.TypeWorkSpace,
        text: this.$t('WORK_AREA').toString(),
      },
      {
        value: GEnum.DragAreaType.TypeDeleteSpace,
        text: this.$t('TRANSFERRING_OR_WITHDRAWING_FROM_SCHOOL').toString(),
      },
      ...this.schoolClasses.map((schoolClass: SchoolClass) => {
        return {
          value: schoolClass.schoolClassID,
          text: schoolClass.schoolClassName,
        };
      }),
    ].filter((option: any) => option.value !== this.fromNameType);
  }

  get fromNameType(): number {
    switch (schoolClassChangeModule.clickDragAreaType) {
      case GEnum.DragAreaType.TypeSchoolClass:
        return schoolClassChangeModule.fromSchoolClassID;
      case GEnum.DragAreaType.TypeDeleteSpace:
        return GEnum.DragAreaType.TypeDeleteSpace;
      case GEnum.DragAreaType.TypeWorkSpace:
        return GEnum.DragAreaType.TypeWorkSpace;
    }
  }

  get moveStudents(): Student[] {
    return this.bulkStudents.filter((student: Student) => student.selected);
  }

  get studentsBySchoolClasses(): StudentsByClass[] {
    return studentModule.studentsBySchoolClasses;
  }

  handleClose() {
    schoolClassChangeModule.setBulkMoveModal(false);
  }

  handleCheckAll() {
    this.checkAll = this.indeterminate ? false : !this.checkAll;

    schoolClassChangeModule.setBulkStudents(
      this.bulkStudents.map((student: Student) => {
        if (student.checked) {
          // ロックされている生徒をスルーする
          return student;
        }
        student.selected = this.checkAll ? true : false;
        return student;
      })
    );

    this.indeterminate = false;
  }

  handleSelectTag(student: Student) {
    student.selected = !student.selected;

    if (this.bulkMoveStudents.length === this.bulkStudents.filter((student: Student) => student.selected).length) {
      this.checkAll = true;
      this.indeterminate = false;
    } else {
      this.checkAll = false;
      if (this.bulkStudents.filter((student: Student) => student.selected).length === 0) {
        this.indeterminate = false;
      } else {
        this.indeterminate = true;
      }
    }
  }

  subStudents(leftStudents: Student[], rightStudents: Student[]) {
    const targetStudentSet: Set<number> = rightStudents.reduce((result: Set<number>, student: Student) => {
      result.add(student.studentID);
      return result;
    }, new Set<number>());

    return leftStudents.filter((student: Student) => !targetStudentSet.has(student.studentID));
  }

  handleBulkMove() {
    let toStudents: Student[] = this.moveStudents.map((student: Student) => {
      student.selected = false;
      student.dragState = GEnum.DragState.Fixed; // 一旦リセット
      return student;
    });

    // fromの生徒の削除
    switch (schoolClassChangeModule.clickDragAreaType) {
      case GEnum.DragAreaType.TypeWorkSpace:
        this.studentDraggableExtraArea.noAssignStudents1 = this.subStudents(this.studentDraggableExtraArea.noAssignStudents1, toStudents);
        this.studentDraggableExtraArea.noAssignStudents2 = this.subStudents(this.studentDraggableExtraArea.noAssignStudents2, toStudents);
        this.studentDraggableExtraArea.noAssignStudents3 = this.subStudents(this.studentDraggableExtraArea.noAssignStudents3, toStudents);
        this.studentDraggableExtraArea.noAssignStudents4 = this.subStudents(this.studentDraggableExtraArea.noAssignStudents4, toStudents);
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        this.studentDraggableExtraArea.deleteStudents = this.subStudents(this.studentDraggableExtraArea.deleteStudents, toStudents).map((student: Student) => {
          student.dragState = GEnum.DragState.Changed;
          return student;
        });
        break;
      case GEnum.DragAreaType.TypeSchoolClass: {
        const schoolClassIndex: number = this.studentsBySchoolClasses.findIndex((studentsBySchoolClass: StudentsByClass) => studentsBySchoolClass.schoolClass.schoolClassID === this.fromNameType);
        if (schoolClassIndex < 0) {
          return;
        }
        this.studentsBySchoolClasses[schoolClassIndex].students = this.subStudents(this.studentsBySchoolClasses[schoolClassIndex].students, toStudents);
        break;
      }
    }
    // toの生徒の反映
    switch (this.selectedSchoolClassID) {
      case GEnum.DragAreaType.TypeWorkSpace:
        this.studentDraggableExtraArea.assignStudents(toStudents);
        break;
      case GEnum.DragAreaType.TypeDeleteSpace:
        this.studentDraggableExtraArea.deleteStudents = this.studentDraggableExtraArea.deleteStudents.concat(
          toStudents.map((student: Student) => {
            student.dragState = GEnum.DragState.Changed;
            return student;
          })
        );
        break;
      default: {
        // 移動先に応じて色を変更
        toStudents = toStudents.map((student: Student) => {
          student.dragState = student.schoolClass.schoolClassID === this.selectedSchoolClassID ? GEnum.DragState.Fixed : GEnum.DragState.Changed;
          return student;
        });
        // 移動先の組の生徒一覧を取得
        let forwardStudentsBySchoolClass: StudentsByClass = this.studentsBySchoolClasses.find(
          (studentsBySchoolClass: StudentsByClass) => studentsBySchoolClass.schoolClass.schoolClassID === this.selectedSchoolClassID
        );
        forwardStudentsBySchoolClass.students = forwardStudentsBySchoolClass.students.concat(toStudents);
        break;
      }
    }

    const toName: string = this.toDragAreaOptions.find((option: any) => option.value === this.selectedSchoolClassID).text;
    this.showNotice(GEnum.MessageType.Success, this.$t('MOVE_STUDENTS_BATCHES').toString(), this.$t('MOVE_STUDENTS_BATCHES_FROM_TO', {value1: this.fromName, value2: toName, value3: toStudents.length}).toString(), 10);

    schoolClassChangeModule.setBulkMoveModal(false);
    this.$emit('refresh');
  }
}
